<h1>Metadaten nutzen</h1>
<section class="article">
  <article>
    <div class="text">
      <p>
        Video-Anleitungen sind digitale Dokumente. Bei der Anwendung von
        video2manual können Metadaten eingefügt werden - zur Dokumentenlenkung
        und/oder um zusätzliche Informationen in den Projekten zu hinterlegen.
      </p>
      <img class="screenshot" src="assets/project_metadata.jpg" />
      <p>
        Metadaten können z. B. erfassen, wer ein Projekt wann erstellt, wer es
        nachträglich bearbeitet hat, an welchen Stellen Änderungen vorgenommen
        wurden, um welchen Revisionsstand es sich handelt u.v.m. Das
        Protokollieren von Änderungen macht den Dokumenten-Lebenszyklus
        übersichtlich und transparent, die Koordinierung des gemeinsamen
        Zugriffs von mehreren Erstellern wird unterstützt und nicht zuletzt
        werden mit der Archivierung der einzelnen Versionsstände/Status
        gesetzliche Aufbewahrungspflichten berücksichtigt.
      </p>
      <p>
        Metadaten können aus folgenden Typen bestehen: Text, Zahl, ja/nein, Bild
      </p>
      <img class="screenshot" src="assets/project_metadata_list.jpg" />
      <p>
        Metadaten können bezogen auf das Gesamt-Projekt, aber auch auf Ebene von
        Menüpunkten, Sequenzen oder für einzelne Clips angelegt werden. So
        können Informationen hinterlegt werden, wie z.&nbsp;B.: <br />
        An welcher Produktionsstätte wurde gedreht? <br />
        Sind die Aufnahmen für alle Produktionsstätten verwendbar? <br />
        Wird ein Clip/eine Sequenz auch in anderen Projekten verwendet (und in
        welchen)? <br />
        Ebenso können alle weiteren für den jeweils spezifischen
        Bearbeitungsprozess und Verwendungszweck relevanten Daten hinterlegt
        werden.
      </p>
      <p>
        Metadaten können auch verwendet werden, um den Dateinamen/die
        Pfadeinstellung zu definieren…
      </p>
      <img class="screenshot" src="assets/path_with_metadata.jpg" />
      <p>… oder um Zwischentitel bei der Archivierung zu erstellen.</p>
      <img class="screenshot" src="assets/subtitle_with_metadata.jpg" />
    </div>
    <a [routerLink]="['/blog']" class="call">Zurück zur Übersicht</a>
  </article>
</section>
